
<input 
  @change="handleChange"
  type="number" 
  ref="input" 
  v-bind="inputAttrs" 
  :value="unrectifiedValue"
  @input="handleInput"
  @keyup="$emit('keyup', $event )"
  tabindex="0"
  @focusout="$emit('focusout')"
  @focus="$emit('focus')"
  @keydown="filterValues">
